import { t } from '@avalara/bat-apps-shared/i18n';

import { HIGHRADIUS_PORTAL_URL } from '../../../lib/constants';
import ExternalLink from '../../external-link';

const PaymentMethodPanel = () => (
  <div data-ref='buy.order-review.payment-method' className='pad-bottom-md'>
    <h2 data-ref='buy.order-review.payment-method.heading' className='pad-bottom-sm'>
      {t('client.order-review.payment-method.heading')}
    </h2>
    <p data-ref='buy.order-review.payment-method.description' className='pad-bottom-sm'>
      {t('client.order-review.payment-method.description')}
    </p>
    <p data-ref='buy.order-review.payment-method.instructions' className='pad-bottom-sm'>
      {t('client.order-review.payment-method.instructions')}
    </p>
    <ExternalLink
      href={HIGHRADIUS_PORTAL_URL}
      alwaysOpenInNewTab
      className='button link'
      color='var(--color-accent-text)'
    >
      {t('client.order-review.payment-method.manage-link')}
    </ExternalLink>
  </div>
);

export default PaymentMethodPanel;
